export default __webpack_public_path__ + "static/media/Group -6.7a8a21a0.png";